import React, { useEffect, useState, forwardRef, useMemo } from 'react';
import DoughnutChart from '../../clients/client-dashboard/doughnutchart/doughnut';
import PieChart from '../../clients/client-dashboard/piechart/piechart';
import { Container, Row, Col } from 'react-bootstrap';
import { ReactComponent as IndiaMap } from '../../clients/client-dashboard/dashboardcontent/IndiaMap.svg';
import './candidatePostDashboard.css';
import Trending from '../../../assets/images/trending.png';
import client_notice_img from '../../../assets/images/notice_image.png';
import client_time_icon from '../../../assets/images/time_icon.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { decodeJWT } from '../../../services/candidateService';
import { useNavigate } from 'react-router-dom';
import Article2Image from '../../../assets/images/Card-No-1.jpeg';
import Article3Image from '../../../assets/images/Card No 5.png';
import Article4Image from '../../../assets/images/profile.jpg';
import Article5Image from '../../../assets/images/Card-No-4.jpeg';
import Article6Image from '../../../assets/images/Card-No-2.jpeg';
import Article7Image from '../../../assets/images/Card-No-6.jpeg';
import Article8Image from '../../../assets/images/Card-No-7.jpeg';
import ArticleImage2 from '../../../assets/images/Card No 8.png';
import ArticleImage3 from '../../../assets/images/About_Us.jpeg';
import ArticleImage4 from '../../../assets/images/blog_detail_2.jpg';
import { Link } from 'react-router-dom';
import Psychometric_Image from '../../../assets/images/Ic_Psychometric Test.png';
import Courses_Image from '../../../assets/images/Ic_Courses.png';
import Counselling_Image from '../../../assets/images/Ic_Counselling.png';
import default_profile_image from '../../content-panes/admin-candidate/candiate-info-nav/img/avatar.png';
import { Image, Button } from 'react-bootstrap';
import ClientFooter from '../../clients/client-dashboard/client-footer/client-footer';
import candidateViewImage from '../../../assets/images/Ic_profile view.png';
import companyHiringImage from '../../../assets/images/Ic_candidate work company.png';
import candidateLocationImage from '../../../assets/images/Ic_candidate location.png';
import candidateWorkTypeImage from '../../../assets/images/Ic_work type.png';
import candidateSalaryImage from '../../../assets/images/Ic_candidate amount.png';

// Custom input component for DatePicker
const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <div className="candidate-custom-input" onClick={onClick} ref={ref}>
        {value && value !== "Invalid Date" ? value : "Select Month"}
        <FontAwesomeIcon icon={faCalendarAlt} className="candidate-calendar-icon" />
    </div>
));

function generateContrastingColors(count) {
    const baseColors = ["#F57141", "#4DB5D9", "#9EDB6B", "#694FD6"];
    const baseHSL = baseColors.map(hexToHSL);

    const colors = [];
    for (let i = 0; i < count; i++) {
        const baseIndex = i % baseHSL.length;
        const [h, s, l] = baseHSL[baseIndex];

        const newLightness = Math.min(80, l + (i * 5) % 30);
        const newSaturation = Math.max(50, s - (i * 5) % 20);

        colors.push(`hsl(${h}, ${newSaturation}%, ${newLightness}%)`);
    }
    return colors;
}

// Helper function to convert HEX to HSL
function hexToHSL(hex) {
    let r = parseInt(hex.substring(1, 3), 16) / 255;
    let g = parseInt(hex.substring(3, 5), 16) / 255;
    let b = parseInt(hex.substring(5, 7), 16) / 255;

    let max = Math.max(r, g, b), min = Math.min(r, g, b);
    let h, s, l = (max + min) / 2;

    if (max === min) {
        h = s = 0;
    } else {
        let d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h = Math.round(h * 60);
    }
    return [h, Math.round(s * 100), Math.round(l * 100)];
}


const fetchData = () => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve({
                recentClients: [
                    // { designation: 'Director', industry: 'Pharmaceuticals', ctc: '36L / annum' },
                    // { designation: 'CEO', industry: 'Chemical', ctc: '68L / annum' },
                    // { designation: 'CFO', industry: 'Textile', ctc: '50L / annum' },
                ],
                notices: [
                    {
                        title: 'Cursus quam vel odio',
                        time: '30 mins Ago',
                        description:
                            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Est eu egestas augue sem habitasse elit, mauris mattis massa. Sollicitudin lacus rhoncus.',
                    },
                    {
                        title: 'Cursus quam vel odio',
                        time: '30 mins Ago',
                        description:
                            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Est eu egestas augue sem habitasse elit, mauris mattis massa. Sollicitudin lacus rhoncus.',
                    },
                ],

                valueAdds: [
                    {
                        title: 'Psychometric Test',
                        image: Psychometric_Image,
                        description:
                            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Est eu egestas augue sem habitasse elit, mauris mattis massa.',
                    },
                    {
                        title: 'Courses',
                        image: Courses_Image,
                        description:
                            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Est eu egestas augue sem habitasse elit, mauris mattis massa.',
                    },
                    {
                        title: 'Counselling',
                        image: Counselling_Image,
                        description:
                            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Est eu egestas augue sem habitasse elit, mauris mattis massa.',
                    },
                ],

                locationData: {
                    delhi: 36,
                    mumbai: 80,
                    hyderabad: 43,
                },
            });
        }, 1000);
    });
};

const CandidatePostDashboard = () => {
    const decoded = decodeJWT(window.localStorage.getItem('authToken'));
    const [page, setPage] = useState(0);
    const [size] = useState(10);
    const [hasNext, setHasNext] = useState(false);
    const [totalPages, setTotalPages] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [imageUrls, setImageUrls] = useState([]);
    const [recentClients, setRecentClients] = useState([]);
    const [shortlistedClients, setShortlistedClients] = useState([]);
    const [notices, setNotices] = useState([]);
    const [valueAdds, setValueAdds] = useState([]);
    const workTypeData = {};
    const navigate = useNavigate();
    const [isShortlistLoading, setIsShortlistLoading] = useState(false);
    const [isRecentSearchLoading, setIsRecentSearchLoading] = useState(false);

    const articles = [
        {
            id: 1,
            title: 'Navigating Career Changes at the Executive Level: Transitioning Roles, Industries, and More',
            date: '26 Feb, 2025',
            readTime: '5 Min Read',
            image: Article3Image,
            author: { name: 'Robbin S', avatar: Article4Image },
            content: `<h2>Navigating Career Changes at the Executive Level: Transitioning Roles, Industries, and More</h2>

<p>Career transitions are often seen as opportunities for growth and new challenges, and nowhere is this truer than at the executive level. Shifting from one industry to another while holding a top-level position can be a transformative experience filled with unique challenges and exciting opportunities. In this blog post, we'll explore the intricacies of navigating such transitions, highlighting the key factors that executives should consider when embarking on a career change between domains.</p>
<h3>1. The Art of Skill Translation:</h3>
<p>One of the initial challenges executives face when transitioning between industries is translating their existing skills and expertise. Discover how to identify transferable skills and apply them effectively in your new industry.</p>
<h3>2. Embracing a Learning Mindset:</h3>
<p>Transitioning to a new industry often means stepping into unfamiliar territory. Unlearning outdated knowledge and adopting a learning mindset are essential for success. Seek opportunities for professional development and education to stay ahead of the curve and develop the skills and expertise you need to thrive in your new role.</p>
<h3>3. Leveraging Your Network:</h3>
<p>Your professional network can be a valuable asset during industry transitions. Learn how to tap into your connections, seek advice, and make new industry-specific contacts.</p>
<h3>4. Navigating Industry-Specific Challenges:</h3>
<p>Different industries come with their own set of challenges and regulations. Delve into strategies for understanding and addressing these unique industry-specific hurdles.</p>
<h3>5. Establishing Credibility:</h3>
<p>Building trust and credibility in a new industry is vital. Discover ways to showcase your expertise and make a compelling case for why you are an asset in your new executive role.</p>
<h3>6. Balancing Industry Experience and Fresh Perspective:</h3>
<p>Executives often bring a fresh perspective when transitioning industries, but they must also respect existing industry norms. Explore the art of balancing your valuable insights with industry traditions.</p>
<h3>7. Cultivating Resilience:</h3>
<p>Career transitions, especially at the executive level, can be demanding. Uncover techniques for cultivating resilience and managing the inevitable challenges that arise during industry shifts.</p>
<h3>8. Measuring Success:</h3>
<p>Determine how to set meaningful goals and key performance indicators (KPIs) to track your success in the new industry.</p>
<h2>Embracing Change at the Executive Level</h2>
<p>Transitioning domains at the executive level is a journey that requires a mix of courage, adaptability, and strategic planning. While it may come with challenges, it also presents exciting opportunities for personal and professional growth. Embrace change, be open to learning, and leverage your existing skills to embark on a successful career transition between fields. Remember that your experience and leadership can be invaluable assets in your new role.</p>
<p>In this ever-evolving professional landscape, career transitions are becoming more common, and they offer executives a chance to explore new horizons, make a lasting impact, and redefine their professional narratives. Whether you're contemplating a domain switch or already in the midst of one, embracing change at the executive level can lead to a rewarding and fulfilling career journey.</p>

`,

        },
        {
            id: 2,
            title: 'Looking Beyond Women For Diversity and Inclusion: Why It\'s Important?',
            date: '19 Feb, 2025',
            readTime: '5 Min Read',
            image: Article8Image,
            author: { name: 'Robbin S', avatar: Article4Image },
            content: `<h2>Looking Beyond Women For Diversity and Inclusion: Why It's Important?</h2>
<p>Diversity and inclusion (D&I) in the workplace have become a top priority for many organizations in recent years. However, many people still focus only on gender diversity when thinking about D&I, which can lead to overlooking other important dimensions of diversity, such as race, ethnicity, sexual orientation, disability, and socioeconomic status.</p>
<h3>Why is it important to look beyond women for D&I?</h3>
<p>There are several reasons why it is important to look beyond women for D&I. First, women are not a monolithic group. They have different experiences, perspectives, and backgrounds, just like everyone else. Second, there are many other groups of people who are also underrepresented in the workplace and deserve to be included. Third, a truly diverse and inclusive workplace is one where everyone feels welcome and valued, regardless of their background or identity.<p>
<h3>How can we look beyond women for D&I?</h3>
<p>Here are a few tips for looking beyond women for D&I:</p>
<ul>
  <li>Expand Your Definition of Diversity. Diversity is about more than just gender. It also includes race, ethnicity, sexual orientation, disability, socioeconomic status, and other dimensions of identity.</li><br>
  <li>Be Intentional About Your Hiring and Promotion Practices. Make sure that you are actively recruiting and promoting people from all different backgrounds.</li><br>
  <li>Create a Culture of Inclusion. Everyone deserves to feel welcome and valued in the workplace. Create a culture where everyone feels comfortable sharing their ideas and perspectives.</li>
</ul>

<h3>What are the benefits of looking beyond just women for D&I?</h3>
<p>There are many benefits to looking beyond just women for D&I. A diverse and inclusive workplace is more innovative, more productive, and more profitable. It is also a more attractive place to work for top talent.</p>
<p>Facts:</p>
<ul>
  <li>A study by McKinsey & Company found that companies with more diverse leadership teams are more likely to outperform their peers financially.</li><br>
  <li>A study by Glassdoor found that companies with high D&I ratings are more likely to be seen as attractive employers.</li><br>
  <li>A study by the Boston Consulting Group found that companies with high D&I ratings are more likely to have innovation cultures.</li>
</ul>

<h3>Future trends in D&I</h3>
<p>In 2023 and beyond, we can expect to see a continued focus on D&I in the workplace. Organizations will be increasingly focused on creating cultures where everyone feels welcome and valued, regardless of their background or identity. We will also see a shift towards a more intersectional approach to D&I, which means recognizing the interconnectedness of different dimensions of identity, such as race, gender, and sexual orientation.</p>
<p>Here are some specific trends that we can expect to see in D&I in the future:</p>
<ul>
  <li>A focus on neurodiversity and disability inclusion.</li>
  <li>A greater emphasis on mental health and well-being.</li>
  <li>A more inclusive approach to parental leave and other family-friendly policies.</li>
  <li>A shift towards remote and hybrid work arrangements can make it easier for people from all backgrounds to participate in the workforce.</li>
</ul>

<p>Looking beyond women for D&I is essential for creating a truly diverse and inclusive workplace. By expanding our definition of diversity, being intentional about our hiring and promotion practices, and creating a culture of inclusion, we can reap the many benefits of a diverse workforce.</p>
<p><strong>Sources:</strong></p>
<ul>
  <li>McKinsey & Company, "Diversity wins: How inclusion matters"</li>
  <li>Glassdoor, "2023 Employee Choice Awards: Best Places to Work"</li>
  <li>Boston Consulting Group, "Diversity Wins: How Inclusion and Diversity Accelerate Innovation"</li>
</ul>

`    ,

        },
        {
            id: 3,
            title: 'Bosses and workers disagree on return to office: How to bridge the gap?',
            date: '12 Feb, 2025',
            readTime: '5 Min Read',
            image: Article2Image,
            author: { name: 'Robbin S', avatar: Article4Image },
            content: `<h2>Bosses and workers disagree on return to office: How to bridge the gap?</h2>
<p>The COVID-19 pandemic has forced many companies to rethink their workplace policies, including remote work. While some companies have embraced remote work wholeheartedly, others are eager to return to the office full-time.</p>
<p>However, there is a disconnect between bosses and workers on the issue of return to office. A recent study found that 76% of mid- and entry-level professionals remain hesitant to work in a shared environment on a full-time basis. Only 17% of work-from-home employees hope to work in their corporate office every day.</p>
<h3>This divergence in opinion can be attributed to several factors, including:</h3>
<ul>
  <li><strong>Different Job Roles:</strong> Executives and non-executive employees often have different job roles and responsibilities. Executives are more likely to meet with clients in person or to collaborate with other executives in the office, whereas non-executive employees are more likely to be able to effectively perform their jobs remotely.</li><br>
  <li><strong>Different Work Preferences:</strong> Some people simply prefer to work in an office setting, while others prefer to work from home. There are many reasons for this, such as personal productivity, work-life balance, and commute time.</li><br>
  <li><strong>Different Levels of Job Satisfaction:</strong> A recent study found that executives' overall satisfaction level increased amid the shift to a physical work environment, while non-executives saw their satisfaction level decrease. This may be because executives have more control over their work environment and schedule.</li>
</ul>

<h3>How to bridge the gap?</h3>
<p>Companies can bridge the gap between bosses and workers on the issue of return to office by:</p>
<ul>
  <li><strong>Embracing Flexibility:</strong> Companies should offer employees a variety of work arrangements, such as full-time remote work, hybrid work, and flexible work hours. This will give employees the flexibility to choose the work arrangement that best suits their needs.</li><br>
  <li><strong>Training and Rewarding Inclusion:</strong> Companies should train managers and employees on how to create and maintain an inclusive workplace culture. This includes providing training on topics such as unconscious bias and remote work etiquette. Companies should also reward employees for their contributions to the team, regardless of where they work from.</li><br>
  <li><strong>Building Connection Through Transparency:</strong> Companies should be transparent with employees about their return-to-office plans. This includes communicating the company's goals for returning to the office, as well as the steps that will be taken to protect employee health and safety. Companies should also provide employees with opportunities to give feedback on the company's return-to-office plans.</li>
</ul>

<p>By taking these steps, companies can create a workplace that is flexible, inclusive, and supportive of all employees, regardless of their job roles, work preferences, or location.</p>
<p>The issue of return to office is a complex one, but it is important that companies listen to their employees and find a solution that works for everyone. By embracing flexibility, training and rewarding inclusion, and building connection through transparency, companies can bridge the gap between bosses and workers on this issue.</p>
 <p><strong>Sources -</p></strong></p>
      <p><a href="https://www.peoplematters.in/news/culture/bosses-workers-dont-see-eye-to-eye-on-return-to-office-31356"
      target="_blank" rel="noopener noreferrer">
      https://www.peoplematters.in/news/culture/bosses-workers-dont-see-eye-to-eye-on-return-to-office-31356
      </a>`,

        },
        {
            id: 4,
            title: 'The Unwavering Importance of Employee Engagement: A Call to Action for Business Leaders',
            date: '5 Feb, 2025',
            readTime: '5 Min Read',
            image: Article6Image,
            author: { name: 'Robbin S', avatar: Article4Image },
            content: `<h2>The Unwavering Importance of Employee Engagement: A Call to Action for Business Leaders</h2>
<p>In the dynamic realm of business, where success hinges on the collective efforts of individuals, employee engagement stands as a beacon of organizational vitality. It's the lifeblood that courses through the veins of a company, fueling innovation, productivity, and ultimately, sustainable growth. To neglect the importance of employee engagement is to risk anaemia in the workplace, leading to stagnation, decline, and potential demise.</p>
<p>Employee engagement is not merely a buzzword or a fleeting trend; it's a profound and multifaceted concept that encompasses the emotional, intellectual, and behavioural connection an employee feels towards their work and their organization. It's the difference between an employee who merely shows up and one who wholeheartedly invests their energy, creativity, and passion.</p>
<p>The benefits of a highly engaged workforce extend far beyond improved morale and reduced turnover. Studies have consistently shown that engaged employees are more productive, innovative, and customer-centric, leading to enhanced financial performance and a stronger competitive edge.</p>
<p>Yet, despite the overwhelming evidence of its benefits, employee engagement remains a critical challenge for many organizations. The fast-paced, demanding nature of modern work, coupled with the increasing prevalence of remote work arrangements, has created a fertile ground for disengagement and burnout.</p>
<p>The onus, therefore, falls upon business leaders to foster a culture of engagement, one that nurtures the intrinsic motivation and well-being of their employees. This requires a holistic approach that encompasses a variety of strategies, from fostering open communication and providing opportunities for growth to recognizing achievements and promoting a sense of purpose.</p>
<h3>Here are a few key steps business leaders can take to cultivate a culture of employee engagement:</h3>
<ol>
  <li><strong>Prioritize Open and Honest Communication:</strong> Encourage open dialogue between employees and management, creating a safe space for feedback and suggestions.</li><br>
  <li><strong>Empower Employees with Autonomy and Ownership:</strong> Provide employees with the freedom to make decisions and take ownership of their work.</li><br>
  <li><strong>Recognize and Reward Achievements:</strong> Celebrate successes, both big and small, to reinforce positive behavior and boost morale.</li><br>
  <li><strong>Invest in Employee Development and Training:</strong> Offer opportunities for continuous learning and skill enhancement, demonstrating a commitment to employee growth.</li><br>
  <li><strong>Foster a Sense of Purpose and Belonging:</strong> Communicate the organization's mission and values, aligning individual contributions to a larger collective impact.</li><br>
  <li><strong>Promote Work-Life Balance:</strong> Encourage a healthy balance between work and personal life, recognizing the importance of employee well-being.</li><br>
  <li><strong>Seek Feedback and Act Upon It:</strong> Regularly solicit employee feedback and use it to drive positive change within the organization.</li>
</ol>
<p>Employee engagement is not a destination but an ongoing journey, requiring consistent effort and dedication from leadership. It's an investment in the human capital that drives the engine of business success.</p>
<p>In closing, business leaders must recognize that employee engagement is not a mere HR initiative but a fundamental pillar of organizational excellence. It's the driving force behind a thriving workplace, where individuals feel valued, empowered, and inspired to contribute their best. By prioritizing employee engagement, organizations not only reap the rewards of enhanced productivity and financial performance but also cultivate a legacy of human connection, innovation, and sustainable success.</p>`,

        },
        {
            id: 5,
            title: 'Building Amazing Communities of Leaders in the Digital Age: A Guide for Thriving in Today\'s Landscape',
            date: '29 Jan, 2025',
            readTime: '5 Min Read',
            image: Article5Image,
            author: { name: 'Robbin S', avatar: Article4Image },
            content: `<h2>Building Amazing Communities of Leaders in the Digital Age: A Guide for Thriving in Today's Landscape</h2>

<p>Forget the corner office, it's time for the leadership circle.  In a world where work is more connected than ever, building communities of diverse, empowered leaders is the key to success.  This blog dives deep, offering insights from 2,000+ leaders on how to unlock your team's full potential. Discover the mindsets and skills needed to navigate the digital age and build a thriving leadership ecosystem.  Ready to unleash your inner leader? Read on!</p>

<h3>The Challenges of Leading in the Digital Age:</h3>
<ul>
  <li><strong>Outdated Mindsets:</strong> Leaders still clinging to old-world thinking struggle to adapt to rapid technological advancements and evolving customer expectations.</li><br>
  <li><strong>Blind Spots:</strong> Unconscious biases and cultural norms can hinder progress and limit the ability to attract and retain diverse talent.</li><br>
  <li><strong>Lack of Collaboration:</strong> Siloed structures and communication gaps impede the flow of ideas and hinder innovation.</li><br>
  <li><strong>Disengagement and Lack of Purpose:</strong> Employees yearning for meaning and connection can become disengaged, leading to decreased productivity and satisfaction.</li>
</ul>
<h3>The 4 Pillars of Amazing Communities of Leaders:</h3>
<ol>
  <li><strong>Creator Mindset:</strong> Cultivate a focus on customer-centricity, data-driven decision-making, and agile execution.</li><br>
  <li><strong>Investor Mindset:</strong> Pursue a higher purpose beyond profits, prioritizing sustainability, community impact, and employee well-being.</li><br>
  <li><strong>Collaborator Mindset:</strong> Foster strong relationships, partnerships, and networks to leverage diverse perspectives and achieve shared goals.</li><br>
  <li><strong>Explorer Mindset:</strong> Embrace curiosity, creativity, and a willingness to experiment in the face of uncertainty.</li>
</ol>


<h3>Building the Foundation:</h3>
<ul>
  <li><strong>Articulate a Powerful Leadership Narrative:</strong> Clearly define your vision for leadership in the digital age and the values that guide it.</li><br>
  <li><strong>Identify Future Leaders Early:</strong> Look for individuals who embody the desired mindsets and behaviors across all levels of your organization.</li><br>
  <li><strong>Empower All Employees:</strong> Create a culture of transparency, trust, and open communication where everyone feels valued and capable of contributing.</li><br>
  <li><strong>Align Talent, Leadership, and Business Strategies:</strong> Ensure your talent acquisition, development, and promotion practices are aligned with your leadership needs.</li><br>
  <li><strong>Embrace and Demand Diversity and Inclusion:</strong> Go beyond lip service and actively cultivate a diverse and inclusive workplace where everyone feels welcome and empowered.</li>
</ul>
<h3>The Future of Leadership:</h3>
<p>The future belongs to leaders who are courageous, adaptable, and purpose-driven. They are the ones who can build thriving communities of leaders, unleashing the collective potential of their organizations to create a better world.</p>
<p>Ready to take the first step? Start by reflecting on your leadership approach and the culture you are fostering. Then, explore the resources and recommendations provided here to begin building your amazing community of leaders.</p>
<p>Creating a thriving community is an ongoing journey, not a destination. Embrace the challenges, celebrate the successes, and keep leading with courage, purpose, and joy!</p>
<p>This blog post is just a starting point. Share your thoughts and experiences in the comments below. Let's continue the conversation about building amazing communities of leaders together!</p>
<p><strong>Sources -</strong></p>
      <p><a href="https://www.peoplematters.in/article/leadership-development/how-can-you-make-your-organisation-an-amazing-community-of-leaders-31962"
      target="_blank" rel="noopener noreferrer">
      https://www.peoplematters.in/article/leadership-development/how-can-you-make-your-organisation-an-amazing-community-of-leaders-31962
      </a></p>
`
            ,

        },
        {
            id: 6,
            title: 'Beyond Talent: Unraveling the Enigma of Professional Success',
            date: '22 Jan, 2025',
            readTime: '5 Min Read',
            image: Article7Image,
            author: { name: 'Robbin S', avatar: Article4Image },
            content: `<h2>Beyond Talent: Unraveling the Enigma of Professional Success</h2>
<p>In a world that celebrates talent and hard work, why do some individuals still find success elusive? This blog explores the nuanced factors that contribute to professional success, delving into the realm beyond skills and diligence. Let's embark on a journey to uncover the hidden dimensions that shape a truly successful career.</p>
<h3>The Myth of Meritocracy:</h3>
<p>Success is often portrayed as a direct result of talent and hard work. However, the reality is more complex. Unravel the myth of meritocracy and understand how factors like networking, timing, and opportunities play pivotal roles.</p>
<h3>Embracing Failure as a Stepping Stone:</h3>
<p>Success and failure are intertwined. Explore the stories of accomplished individuals who faced setbacks before reaching their pinnacle. Learn how resilience, adaptability, and a growth mindset can turn failures into stepping stones toward success.</p>
<h3>The Power of Emotional Intelligence:</h3>
<p>Beyond technical skills, emotional intelligence is a game-changer. Understand how empathy, self-awareness, and effective communication contribute to building strong professional relationships and opening doors to new opportunities.</p>
<h3>Navigating the Corporate Landscape:</h3>
<p>Climbing the corporate ladder requires more than just hard work. Decode the unwritten rules of office politics, effective communication, and strategic positioning to ensure your efforts are recognized and rewarded.</p>
<h3>Investing in Continuous Learning:</h3>
<p>The professional landscape is ever-evolving. Stay ahead by embracing a mindset of continuous learning. Explore how acquiring new skills and adapting to industry trends can set you apart in a competitive environment.</p>

<h3>Building a Personal Brand:</h3>
<p>In a world crowded with talent, standing out is crucial. Delve into the concept of personal branding and understand how showcasing your unique strengths and values can elevate your professional profile.</p>
<h3>Cultivating a Growth Mindset:</h3>
<p>Success is not a destination but a journey. Cultivate a growth mindset that thrives on challenges and sees effort as a path to mastery. Discover how this mindset fosters resilience and propels you toward continuous improvement.</p>
<p>In the quest for professional success, talent and hard work are essential, but they're just the beginning. This blog aims to spark introspection and guide you toward a holistic approach that encompasses the often-overlooked elements contributing to a truly successful and fulfilling career. Are you ready to redefine your path to success? Let's embark on this transformative journey together.</p>

`
            ,

        },
        {
            id: 7,
            title: 'The Looming Shadow: Navigating Layoffs with Humanity and Hope',
            date: '15 jan, 2025',
            readTime: '6 Min Read',
            image: ArticleImage2,
            author: { name: 'John Doe', avatar: ArticleImage4 },
            content: `<h2>The Looming Shadow: Navigating Layoffs with Humanity and Hope</h2>
    <p>The storm clouds of economic uncertainty gather, and their first drops are felt in the form of rising layoff numbers. A staggering 40% of companies anticipate shedding jobs in 2024, a grim statistic that sends shivers down the spines of both employers and employees. While cost-cutting might seem like the logical answer, the human cost of layoffs can be immense, impacting individuals, families, and even the companies themselves.</p>
    <p>But amidst the gloom, there's a glimmer of hope. By prioritizing transparency, compassion, and support, we can navigate this turbulent period with a semblance of grace. Here's a compass to guide us through the choppy waters:</p>
    <p><strong>Honesty, the Best Policy:</strong> Shrouding layoffs in secrecy breeds fear and resentment. Be upfront about the "why" behind the cuts, explaining the rationale objectively and clearly. Remember, even bad news delivered honestly is easier to swallow than shrouded uncertainty.</p>
    <p><strong>Beyond the Severance Package:</strong> A hefty severance package might ease the immediate financial burden, but true support goes beyond the paycheck. Offer resources like career counseling, resume workshops, and connections to potential employers. Empowering individuals to land on their feet fosters goodwill and reflects positively on your company.</p>
    <p><strong>The Long Goodbye:</strong> Consider a more humane approach - the "long goodbye." This extended period allows departing employees to share knowledge, transition smoothly, and secure new opportunities while still drawing a paycheck. It's a win-win, demonstrating compassion and minimizing disruption.</p>
    <p><strong>Building Bridges, Not Walls:</strong> Don't sever ties with departing employees. Stay connected! Periodic check-ins, job leads, and updates on company developments show you care and keep the network alive. These individuals might boomerang back someday, bringing valuable experience and renewed loyalty.</p>
    <p><strong>Mind the Survivors:</strong> The burden doesn't solely fall on those leaving. "Survivor's guilt" and increased workload can weigh heavily on remaining employees. Open communication, regular check-ins, and readily available resources like Employee Assistance Programs are crucial to navigate this emotional rollercoaster.</p>
    <p><strong>Rethink, Reconsider:</strong> Before wielding the layoff axe, explore alternatives. Can hiring freezes, pay cuts, or temporary measures buy you time? Remember, layoffs often come at a hidden cost - reduced innovation, lower morale, and ultimately, hindered growth.</p>
    <p>Remember, layoffs are a complex issue with no easy answers. But by prioritizing humanity, transparency, and support, we can navigate this difficult terrain with a modicum of dignity and hope. Let's strive to create a future where economic realities don't overshadow our responsibility to each other, where job losses are met with empathy and a commitment to rebuild, together.</p>
    <p>Let's turn this looming shadow into an opportunity for growth, for learning, and for building a more resilient, humane workplace. It's a challenge, but together, we can weather the storm.</p>
    <p><strong>Source -</p></strong> <a href="https://www.hrmorning.com" target="_blank" rel="noopener noreferrer">
          www.hrmorning.com
          </a>
   
    `
        },
        {
            id: 8,
            title: 'Finding the Perfect Work-Life Balance with a Leader by Your Side 🚀',
            date: '8 Jan, 2025',
            readTime: '5 Min Read',
            image: ArticleImage3,
            author: { name: 'Sarah Johnson', avatar: ArticleImage4 },
            content: `<h2>Finding the Perfect Work-Life Balance with a Leader by Your Side 🚀</h2>
          <p>Let's talk about that ever-elusive goal we all chase after - WORK-LIFE BALANCE. It's like trying to juggle flaming torches while riding a unicycle on a tightrope - challenging but not impossible! The secret to achieving this mythical equilibrium lies in having a fantastic leader by your side. Today, we want to share some insights on how a great leader can help all of us find that sweet spot between career success and personal fulfillment.</p>
    <h3>Understanding the Priorities</h3>
    <p>A remarkable leader knows that employees are not just cogs in the corporate machine. They take the time to understand employees' priorities, values, and aspirations beyond the workplace. By recognizing the importance of one’s personal lives, they create an environment that encourages others to pursue their passions outside of work.</p>
    <h3>Flexible Work Arrangements</h3>
    <p>A leader worth their salt understands that the traditional 9-to-5 work schedule doesn't always fit into everyone's life puzzle. By embracing flexibility, a leader can offer remote work options, flexible hours, or compressed workweeks. This allows employees to attend to personal commitments and responsibilities without sacrificing their professional dedication.</p>
    <h3>Leading by Example</h3>
    <p>Leaders who practice what they preach are like beacons of inspiration. When they demonstrate a healthy work-life balance themselves, it sends a powerful message to the team. It encourages them to prioritize their well-being, reminding them that their productivity and creativity will flourish when they are mentally and physically refreshed.</p>
    <h3>Encouraging Time Off</h3>
    <p>Everyone needs a break from time to time, and a supportive leader understands the importance of taking time off to recharge. They actively encourage employees to use their vacation days, sick leaves, and mental health days when needed. They create an atmosphere where rest is valued and not stigmatized.
    </p>
    <h3>Promoting Well-being Initiatives</h3>
    <p>Incorporating well-being initiatives into the company culture shows that a leader genuinely cares about the team's health and happiness. Whether it's organizing yoga sessions, meditation workshops, or mental health seminars, these activities foster a positive work environment.</p>
    <h3>Open Communication</h3>
    <p>Effective leaders are approachable and receptive to feedback. They create an open-door policy, making it easier for employees to discuss their work-life balance concerns without fear of judgment. Open communication ensures that everyone's needs are heard and addressed.</p>
    <h3>Celebrating Milestones, Big and Small</h3>
    <p>A leader who acknowledges both professional and personal milestones makes the journey worthwhile. Whether it's congratulating an employee on a job well done or celebrating birthdays, anniversaries, or other life events, this recognition fosters a sense of belonging and appreciation.</p>
    <p>In conclusion, finding the perfect work-life balance is a team effort, and a supportive leader is a crucial part of that equation. By prioritizing employee well-being, offering flexibility, and encouraging open communication, you can empower your team to lead happier, more fulfilling lives inside and outside the workplace.</p>
    <p>So, let's raise a virtual toast to all the amazing leaders out there who champion work-life balance and help us master the art of juggling work and play! 🥂</p>
    <p>#WorkLifeBalance #LeadershipMatters #LifeHacks #EmployeeWellbeing</p>
          `
        },
        {
            id: 9,
            title: '🚀Workplace Predictions for 2024: Navigating the Future of Work! 🌐',
            date: '1 Jan, 2025',
            readTime: '7 Min Read',
            image: ArticleImage4,
            author: { name: 'Michael Lee', avatar: ArticleImage4 },
            content: `<h2>🚀Workplace Predictions for 2024: Navigating the Future of Work! 🌐</h2>
          <p>Nine groundbreaking workplace predictions, providing a roadmap for CHROs to steer their organizations through the evolving landscape of talent acquisition and retention in 2024 and beyond.</p>
          <h3>1. Cost-of-Work Crisis Reaches a Breaking Point</h3>
          <p>As remote work becomes the norm, employees keenly feel the costs associated with returning to the office. In response, organizations are set to address this crisis by sharing tangible and intangible costs, introducing benefits like caregiving support, housing subsidies, and more.</p>
          <h3>2. AI Creates Workforce Opportunity</h3>
          <p>Contrary to fears, Generative AI (GenAI) is predicted to create opportunities by enhancing roles, lowering technical skill requirements, and reshaping hiring strategies. HR leaders are urged to assess GenAI's impact on team roles and workflows.</p>
          <h3>3. Four-Day Workweeks Go from Radical to Routine</h3>
          <p>Embracing a four-day workweek (4DWW) gains traction as organizations reevaluate the workweek cadence to enhance employee engagement, performance, and overall well-being. The 4DWW model is positioned as a strategic tool to improve talent outcomes and drive business efficiency. The Indian state of Kerala became the first in the country to officially implement a 4DWW model for government employees in September 2023. While it's still early days, initial reports suggest promising trends:</p>
         <ul>
      <li><strong>Employee Morale:</strong> Increased employee engagement and reduced stress levels have been observed.</li><br>
      <li><strong>Work-Life Balance:</strong> Employees report having more time for family, hobbies, and personal development.</li><br>
      <li><strong>Government Efficiency:</strong> There are indications of improved productivity and streamlined processes.</li>
    </ul>
    <h3>4. Employee Conflict Resolution is a Must-Have Skill</h3>
          <p>With global crises on the rise, employee conflicts are expected to peak in 2024. Effective conflict resolution becomes a critical skill for managers to maintain organizational harmony. Training programs and recognition mechanisms are recommended to equip and appreciate conflict resolution skills.</p>
          <h3>5. Generative AI Experiments Yield Lessons and Costs</h3>
          <p>While excitement surrounds GenAI, organizations must actively manage risks, including stricter access policies and quality control. The focus is on training employees to exercise judgment in using GenAI tools, balancing potential benefits with potential pitfalls.</p>
          <h3>6. Skills Overtake Degrees as the Paper Ceiling Crumbles</h3>
          <p>Organizations are breaking away from traditional degree-centric hiring, and embracing skills-based recruitment. This shift opens doors to a broader talent pool and emphasizes the importance of skills over degrees in the evolving job market.</p>
          <h3>7. Climate Change Protection Becomes a New Employee Benefit</h3>
          <p>As climate-related events become more widespread, organizations prioritize climate change protection in their benefits packages. Commitments to physical safety, compensation, and mental health support during disasters emerge as key offerings.</p>
          <h3>8. DEI Embeds Itself in Organizational Culture</h3>
          <p>Diversity, Equity, and Inclusion (DEI) transition from standalone initiatives to integral parts of organizational culture. The focus is on integrating DEI values into daily operations, business objectives, and corporate ethos.</p>
          <h3>9. Career Stereotypes Collapse in the Face of Workforce Change</h3>
          <p>Traditional career paths dissolve as atypical career trajectories become mainstream. Employers break free from talent stereotypes, offering flexible work arrangements, gig opportunities, and recognizing expertise beyond conventional career progressions.</p>
          <p🌟 These predictions underscore the dynamic nature of the modern workplace, urging HR leaders to proactively address these trends for a resilient and adaptive workforce in 2024. </p>
          <p>#FutureOfWork #GartnerPredicts #WorkplaceInnovation 🌐👩‍💼🚀</p>
    <p><strong>Source -</p>
    </strong> <a href="https://www.communicationstoday.co.in/gartner-unveils-top-9-workplace-predictions-for-hr-leaders-in-2024/" target="_blank" rel="noopener noreferrer">
          https://www.communicationstoday.co.in/gartner-unveils-top-9-workplace-predictions-for-hr-leaders-in-2024/
          </a>
          `
        },
    ];

    const handleTrendingClick = (title) => {
        const selectedArticle = articles.find((article) => article.title === title);
        if (selectedArticle) {
            sessionStorage.setItem("articleData", JSON.stringify(selectedArticle));
            sessionStorage.removeItem("scrollPosition");
            sessionStorage.removeItem("initialScrollPosition");
            window.location.href = "/blogdetails";
        }
    };
    useEffect(() => {
        fetchData().then((data) => {
            setNotices(data.notices);
            setValueAdds(data.valueAdds)
        });
    }, []);
    const totalSearch = {
        labels: ['Viewed', 'Shortlisted'],
        datasets: [
            {
                data: [10, 5],
                backgroundColor: ['#f9cd1a', '#ef5d28'],
                hoverBackgroundColor: ['#f9cd1a', '#ef5d28'],
            },
        ],
    };

    const RoleData = {
        labels: ['Pharma', 'Education', 'IT', 'Finance', 'Others'],
        datasets: [
            {
                data: [20, 20, 20, 20, 20],
                backgroundColor: ['#F59C00', '#1C8EB4', '#F57400', '#294CB5', '#B500F5'],
                hoverBackgroundColor: ['#F59C00', '#1C8EB4', '#F57400', '#294CB5', '#B500F5'],
            },
        ],
    };


    const location = {
        labels: ['Chennai', 'Mumbai', 'Pune', 'Bangalore', 'Delhi'],
        datasets: [
            {
                data: [20, 20, 20, 20, 20],
                backgroundColor: ['#F57400', '#1C8EB4', '#4D1CB4', '#C3D039', '#F8C400'],
                hoverBackgroundColor: ['#F57400', '#1C8EB4', '#4D1CB4', '#C3D039', '#F8C400'],
            },
        ],
    };

    const countsalaryRangeData = {
        labels: ['CEO', 'Director', 'CFO', 'Others'],
        datasets: [
            {
                data: [25, 25, 30, 20],
                backgroundColor: ['#2C51BE', '#1E96BE', '#C3D039', '#37B38B'],
                hoverBackgroundColor: ['#2C51BE', '#1E96BE', '#C3D039', '#37B38B'],
            },
        ],
    };

    const countdesignationData = {
        labels: ['Pharma', 'Education', 'IT', 'Finance', 'Others'],
        datasets: [
            {
                data: [20, 20, 20, 20, 20],
                backgroundColor: ['#F59C00', '#1C8EB4', '#F57400', '#294CB5', '#B500F5'],
                hoverBackgroundColor: ['#F59C00', '#1C8EB4', '#F57400', '#294CB5', '#B500F5'],
            },
        ],
    };

    const countWorkType = {
        labels: ['Hybrid', 'WFH', 'On Site'],
        datasets: [
            {
                data: [35, 20, 45],
                backgroundColor: ['#37B38B', '#1E96BE', '#374BB3'],
                hoverBackgroundColor: ['#37B38B', '#1E96BE', '#374BB3'],
            },
        ],
    };

    const profiles = [
        {
            profileImage: default_profile_image,
            name: "Tushita Shekhar",
            designation: "HOD, Abbott",
            views: 5,
            companiesHiring: 55,
            salary: 65,
            workType: "WFH",
            locations: ["Delhi", "Pune", "Hyderabad", "Mumbai"],
        },
    ];
    return (
        <div>
            <div className="container-fluid candidate-dashboard-container-fluid">
                {/* <div className='client-dashboard-button'></div> */}
                <div className="candidate-dashboard-title ">
                    <div className="candidate-month-selector ">
                        <DatePicker
                            dateFormat="yyyy/MM"
                            showMonthYearPicker
                            maxDate={new Date()}
                            customInput={<CustomInput />}
                        />
                    </div>
                </div>
                <div>
                    {profiles.map((profile, index) => (
                        <Row className="candidate-dashboard-card p-3 d-flex flex-column flex-md-row align-items-center border rounded bg-white mb-3">
                            {/* Profile Section */}
                            <Col md={4} className="d-flex mb-3 mb-md-0">
                                <div className="rounded-circle overflow-hidden position-relative profile-image-wrapper">
                                    <Image
                                        src={profile.profileImage}
                                        alt="Profile Image"
                                        className="img-fluid rounded-circle"
                                        width={80}
                                        height={80}
                                    />
                                </div>
                                <div className="ms-3">
                                    <h5 className="candidate-name">{profile.name}</h5>
                                    <p className="candidate-designation mb-1">{profile.designation}</p>
                                    <div className="progress" style={{ height: '8px', width: '194px' }}>
                                        <div
                                            className="progress-bar"
                                            role="progressbar"
                                            style={{ width: '100%', backgroundColor: '#f35824' }}
                                        ></div>
                                    </div>
                                    <p className="candidate-progress">100% Completed</p>
                                    <Button className="candidate-dashboard-button">Update</Button>
                                </div>
                                <div className="candidate-profile-red-dotted-line"></div>

                            </Col>

                            {/* Details Section */}
                            <Col md={8}>
                                <Row className="details-container">
                                    {[
                                        {
                                            label: 'Profile Viewed',
                                            value: profile.views,
                                            icon: candidateViewImage,
                                        },
                                        {
                                            label: 'No. of Companies Hiring',
                                            value: profile.companiesHiring,
                                            icon: companyHiringImage,
                                        },
                                        {
                                            label: 'Current Salary',
                                            value: `${profile.salary} Lakhs / Per Annum`,
                                            icon: candidateSalaryImage,
                                        },
                                        {
                                            label: 'Preferred Work Type',
                                            value: profile.workType,
                                            icon: candidateWorkTypeImage,
                                        },
                                        {
                                            label: 'Preferred Location',
                                            value: `${profile.locations.join(', ')}${profile.extraLocations > 0
                                                ? ` +${profile.extraLocations} More`
                                                : ''
                                                }`,
                                            icon: candidateLocationImage,
                                        },
                                    ].map((detail, index) => (
                                        <Col
                                            key={index}
                                            xs={12}
                                            sm={6}
                                            lg={4}
                                            className="d-flex detail-item mb-2"
                                        >
                                            <div className="detail-icon">
                                                <Image src={detail.icon} width={20} height={20} alt="icon" />
                                            </div>&nbsp;&nbsp;
                                            <div>
                                                <p className="detail-head mb-1">{detail.label}</p>
                                                <strong className="detail-values">{detail.value}</strong>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </Col>
                        </Row>

                    ))}
                    <Row>
                        <Col md={6} className="mb-4">
                            <div className="candidate-dashboard-card p-3">
                                <h3>Total Search as per Role</h3>
                                <DoughnutChart data={totalSearch} chartType="subscription" centerText="Total" centerData="100" />
                            </div>
                        </Col>
                        <Col md={6} className="mb-4">
                            <div className="candidate-dashboard-card p-3">
                                <h3>Sector of Company as Per Role</h3>
                                <DoughnutChart
                                    data={RoleData}
                                    chartType="designation"
                                    centerText="Total"
                                    centerData="100"
                                />
                            </div>
                        </Col>
                    </Row>
                </div>

                <div className="candidate-card-section">
                    <div className="candidate-recent-search-card">
                        <div className="candidate-recentsearch-view-container">
                            <h3>Suggested Value Add</h3>
                        </div>
                        {valueAdds.map((valueAdd, index) => (
                            <div className="candidate-notice-item" key={index}>
                                <div className='valueAdd-icon'>
                                    <img src={valueAdd.image} alt="Notice" className="candidate-valueAdd-image" />
                                </div>
                                <div className="candidate-valueAdd-content">
                                    <div className="candidate-notice-text">
                                        <div className="candidate-valueAdd-header" style={{ display: 'flex', justifyContent: 'space-between' }} >
                                            <h4>{valueAdd.title}</h4>
                                            <span
                                                className="view-link"
                                                style={{ color: '#F35824', cursor: 'pointer', fontSize: '14px', fontWeight: '600', marginRight: '10px' }}
                                            >
                                                View
                                            </span>
                                        </div>
                                        <p>{valueAdd.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="candidate-shortlisted-candidates-card">
                        <div className="candidate-notice-header-container">
                            <h3>Leaderly Notice Board</h3>
                            <a href="#" className="candidate-view-all">View All</a>
                        </div>
                        {notices.map((notice, index) => (
                            <div className="candidate-notice-item" key={index}>
                                <div className="candidate-notice-vertical-line"></div>
                                <img src={client_notice_img} alt="Notice" className="candidate-notice-image" />
                                <div className="candidate-notice-content">
                                    <div className="candidate-notice-text">
                                        <div className="candidate-notice-header">
                                            <h4>{notice.title}</h4>
                                            <div className="candidate-notice-time">
                                                <img src={client_time_icon} alt="Time Icon" className="Candidate-time-icon" />
                                                <span>{notice.time}</span>
                                            </div>
                                        </div>
                                        <p>{notice.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="candidate-bottom-card-section">
                    <div className="container">
                        <div className="row candidate-bottom-card-head">
                            <h3>Leaderly Strength</h3>
                        </div>
                        <div className="row candidate-chart-row">
                            <div className="col">
                                <h5>Sectors of Companies</h5>
                                <DoughnutChart data={countdesignationData} chartType="countdesignation" centerText="Total" centerData="20" />

                            </div>
                            <div className="candidate-red-dotted-line"></div>
                            <div className="col">
                                <h5>Average Salary By Role</h5>
                                <PieChart data={countsalaryRangeData} />

                            </div>
                            <div className="candidate-red-dotted-line"></div>
                            <div className="col">
                                <h5>Openings as Per Popular Locations</h5>
                                <PieChart data={location} chartType="candidatecount" />

                            </div>
                            <div className="candidate-red-dotted-line"></div>
                            <div className="col workTypeDoughNutChartContainer">
                                <h5>Work Type</h5>
                                <DoughnutChart data={countWorkType} chartType="countgender" centerText="Total" centerData="100%" />

                            </div>
                        </div>
                    </div>
                </div>

                <div className="candidate-section-container">
                    <div>
                        <div className="candidate-trending-card">
                            <h3>Trending Topics</h3>
                            <ul>
                                {articles.map((article) => (
                                    <li key={article.id}>
                                        <img src={Trending} alt="trending" className="candidate-trending" />
                                        <Link to="#" onClick={(e) => { e.preventDefault(); handleTrendingClick(article.title); }} className="candidate-trending-link">{article.title}</Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div >
                        <div className="client-candidate-locationhiring-card">
                            <h3>Location Hiring as Per your Role</h3>
                            <div className="candidate-india-map-container">
                                <div>
                                    <IndiaMap className="candidate-india-map" />
                                    <div className="candidate-location-marker delhi">
                                        <div className="candidate-percentage-circle red">36%</div>
                                        <div className="candidate-line-container delhi-line red-line"></div>
                                        <span>Delhi</span>
                                    </div>
                                    <div className="candidate-location-marker mumbai">
                                        <div className="candidate-percentage-circle orange">80%</div>
                                        <div className="candidate-line-container mumbai-line orange-line"></div>
                                        <span>Mumbai</span>
                                    </div>
                                    <div className="candidate-location-marker hyderabad">
                                        <div className="candidate-percentage-circle yellow">43%</div>
                                        <div className="candidate-line-container hyderabad-line yellow-line"></div>
                                        <span>Hyderabad</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div><br />
            <ClientFooter />
        </div>
    );
};

export default CandidatePostDashboard;
